export const AuTechnoBtnConfig = {
	ghost: {
		className: 'ghost',
		rippleColor: 'rgba(87, 81, 184, 0.05)',
	},
	primary: {
		className: 'primary',
		rippleColor: 'rgba(255, 255, 255, 0.1)',
	},
	secondary: {
		className: 'secondary',
		rippleColor: 'rgba(255, 255, 255, 0.1)',
	},
	attention: {
		className: 'attention',
		rippleColor: 'rgba(255, 255, 255, 0.1)',
	},
};
